// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
        >
            <rect x="0" y="0" width="24" height="24" rx="2"></rect>
            <g id="Search-plus" transform="translate(5.000000, 4.750000)" fillRule="nonzero">
                <path d="M13.7839845,12.8789062 L10.119922,9.21484375 C10.9128908,8.24414062 11.375,7.02187467 11.375,5.6875 C11.375,2.54652357 8.82929671,0 5.6875,0 C2.54570329,0 0,2.54652357 0,5.6875 C0,8.82847643 2.54652357,11.375 5.68750042,11.375 C7.02160221,11.375 8.2455079,10.9126171 9.21484417,10.1434373 L12.8789067,13.8074998 C13.0074226,13.9371097 13.1769534,14 13.3437504,14 C13.5105475,14 13.6795316,13.9359064 13.8077739,13.8077459 C14.0628907,13.5515627 14.0628907,13.1359373 13.783985,12.8789062 L13.7839845,12.8789062 Z M5.68750042,10.0625 C3.27523476,10.0625 1.31250042,8.09976566 1.31250042,5.6875 C1.31250042,3.27523434 3.27523476,1.3125 5.68750042,1.3125 C8.09976608,1.3125 10.0625004,3.27523434 10.0625004,5.6875 C10.0625004,8.09976566 8.0992195,10.0625 5.68750042,10.0625 Z M7.87500042,5.03125 L6.31914121,5.03125 L6.31914121,3.5 C6.31914121,3.13742161 6.02546918,2.84375 5.68750042,2.84375 C5.34953165,2.84375 5.03125042,3.13632846 5.03125042,3.5 L5.03125042,5.03125 L3.47539079,5.03125 C3.13632804,5.03125 2.84375,5.32382804 2.84375,5.6875 C2.84375,6.05117196 3.13714832,6.34375 3.47539079,6.34375 L5.03125042,6.34375 L5.03125042,7.875 C5.03125042,8.23757839 5.32464874,8.53125 5.66289121,8.53125 C6.02546918,8.53125 6.294532,8.23757839 6.294532,7.875 L6.294532,6.34375 L7.825782,6.34375 C8.23867196,6.34375 8.53125042,6.05117196 8.53125042,5.6875 C8.53125042,5.32382804 8.23867196,5.03125 7.87500042,5.03125 Z"></path>
            </g>
        </svg>
    );
};

export default React.memo(Twitter);
